module.exports = __webpack_public_path__ + "public/img/Menghitung Tunjangan Di Excel Untuk HR.9a419882.png";